import MyEventsProps from './MyEventsProps'

const MyEvents = (props: MyEventsProps) => {
    return (
        <h1>MyEvents</h1>
    )
}

export default MyEvents;